import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

import { useStyles } from './styles';
import FormGroup from '@material-ui/core/FormGroup';

const FormChip = ({ color, variant, fullWidth, title, label, valueName, value, disabled, handleChange }) => {
	const classes = useStyles({
		color,
		variant,
		fullWidth,
		numberOfChips: value ? value.length : 0
	});

	return (
		<FormControl component="fieldset">
			{title && (
				<FormLabel component="legend" className={classes.formLabel}>
					<Typography variant="body2" color="textPrimary">
						{title}
					</Typography>
				</FormLabel>
			)}

			<FormGroup className={classes.formGroup}>
				<Chip
					label={label}
					onClick={() => {
						handleChange({
							target: {
								name: valueName,
								value: !value
							}
						});
					}}
					disabled={disabled}
					className={clsx(classes.chip, {
						[classes.selectedChip]: value
					})}
				/>
			</FormGroup>
		</FormControl>
	);
};

FormChip.propTypes = {
	color: PropTypes.oneOf(['primary', 'secondary']),
	variant: PropTypes.oneOf(['default', 'outlined']),
	fullWidth: PropTypes.bool,
	label: PropTypes.string,
	value: PropTypes.oneOf([PropTypes.arrayOf(PropTypes.string), PropTypes.string]).isRequired,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool
};

export default FormChip;
